module.exports = __webpack_public_path__ + "img/walletlink.f9362e76.png";